// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__1ZPAi","selected":"Chip_selected__143-p"};